import { Component, OnInit, } from '@angular/core';
import { Router, NavigationEnd, } from '@angular/router';
import { TokenService, UserService, } from '@socrates/socrates-shared';
const focusInterval: number = 60 * 10 * 1000;

@Component({
	selector: 'body',
	template: '<router-outlet></router-outlet>',
	standalone: false,
})
export class AppComponent implements OnInit {
	private lastSessionCheck: Date = new Date();

	constructor(
		private router: Router,
		private tokenService: TokenService,
		private userService: UserService,
	) {
	}

	ngOnInit() {
		// Re-check session when the tab regains focus after a long absence
		window.onfocus = () => {
			const now = new Date();
			if (now.getTime() - this.lastSessionCheck.getTime() > focusInterval) {
				this.lastSessionCheck = now;
				this.userService.checkSession().catch(() => {
					this.userService.detouredRoute = this.router.url;
					this.router.navigateByUrl('/login');
				});
			}
		};

		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0);
		});

		// Schedule a token refresh shortly before expiry
		this.userService.subscribeToLogins(() => this.scheduleRefresh());
	}

	private scheduleRefresh(): void {
		const tokens = this.tokenService.getTokens();
		if (!tokens) return;

		const delta = tokens.expiresAt - Date.now() - 60 * 1000; // 1 min before expiry
		if (delta <= 0) {
			this.userService.logout();
			this.router.navigateByUrl('/login');
			return;
		}

		setTimeout(() => {
			this.tokenService.refresh()
				.then(() => this.scheduleRefresh())
				.catch(() => {
					this.userService.logout();
					this.router.navigateByUrl('/login');
				});
		}, delta);
	}
}
